module.exports = __webpack_public_path__ + "static/media/second_degree_icon.442a68e8.svg";